import React from 'react'
import { GraphEdge } from 'dagre'

interface RecipeHoverEdgeProps {
  edge: GraphEdge
}

const RecipeHoverEdge: React.FunctionComponent<RecipeHoverEdgeProps> = ({ edge }) => {
  const { points } = edge

  const { x: ax, y: ay } = points[0]
  const { x: bx, y: by } = points[points.length - 1]
  const { mx, my } = { mx: (ax + bx) / 2, my: (ay + by) / 2 }

  const d =
    ay === by
      ? `M ${ax} ${ay} C ${mx} ${my} ${mx} ${my} ${bx} ${by}`
      : `M ${ax} ${ay} C ${ax + 0.75 * (mx - ax)} ${ay} ${bx - 0.75 * (mx - ax)} ${by} ${bx} ${by}`

  return (
    <g className="recipe-hover-edge">
      <defs>
        <marker
          id="arrow-over"
          viewBox="5 0 10 10"
          refX={10}
          refY={5}
          markerWidth={5}
          markerHeight={5}
          orient="auto-start-reverse"
        >
          <path d="M 5 0 L 15 5 L 5 10 z" stroke="none" fill="#555" />
        </marker>
      </defs>
      <path d={d} stroke="#555" strokeWidth="4px" fill="none" opacity="0.01" markerEnd="url(#arrow-over)" />
      <circle r="3" cx={ax} cy={ay} stroke="none" fill="#555" />
      <path d={d} stroke="#555" strokeWidth="1.5px" fill="none" markerEnd="url(#arrow-over)" />
      <style jsx>{`
        .recipe-hover-edge {
          opacity: 0;
        }

        .recipe-hover-edge:hover {
          opacity: 1;
        }
      `}</style>
    </g>
  )
}

export default RecipeHoverEdge
